import { 
  configuratorData13, layoutData13, profileData13, sceneData13,
  configuratorData29, layoutData29, profileData29, sceneData29,
  configuratorData21, layoutData21, profileData21, sceneData21,
  configuratorData5, layoutData5, profileData5, sceneData5,
  configuratorData53, layoutData53, profileData53, sceneData53,
  configuratorData9, layoutData9, profileData9, sceneData9,
  configuratorData12, layoutData12, profileData12, sceneData12,
  configuratorData10, layoutData10, profileData10, sceneData10,
  configuratorData8, layoutData8, profileData8, sceneData8,
  configuratorData24, layoutData24, profileData24, sceneData24,
  configuratorData222, layoutData222, profileData222, sceneData222, 
  configuratorData76, layoutData76, profileData76, sceneData76, 
  configuratorData68, layoutData68, profileData68, sceneData68, 
  configuratorData64, layoutData64, profileData64, sceneData64, 
  configuratorData57, layoutData57, profileData57, sceneData57, 
  configuratorData75, layoutData75, profileData75, sceneData75, 
  configuratorData67, layoutData67, profileData67, sceneData67, 
  configuratorData6, layoutData6, profileData6, sceneData6, 
  configuratorData284, layoutData284, profileData284, sceneData284, 
  configuratorData14, layoutData14, profileData14, sceneData14, 
  configuratorData15, layoutData15, profileData15, sceneData15, 
  configuratorData121, layoutData121, profileData121, sceneData121, 
  configuratorData113, layoutData113, profileData113, sceneData113, 
  configuratorData73, layoutData73, profileData73, sceneData73, 
  configuratorData72, layoutData72, profileData72, sceneData72,
  configuratorData49, layoutData49, profileData49, sceneData49,
  configuratorData62, layoutData62, profileData62, sceneData62,
  configuratorData25, layoutData25, profileData25, sceneData25,
  configuratorData51, layoutData51, profileData51, sceneData51,
  configuratorData58, layoutData58, profileData58, sceneData58,
  configuratorData69, layoutData69, profileData69, sceneData69,
  configuratorData23, layoutData23, profileData23, sceneData23,
  configuratorData60, layoutData60, profileData60, sceneData60,
  configuratorData132, layoutData132, profileData132, sceneData132,
  configuratorData27, layoutData27, profileData27, sceneData27,
  configuratorData77, layoutData77, profileData77, sceneData77,
  configuratorData17, layoutData17, profileData17, sceneData17,
  configuratorData123, layoutData123, profileData123, sceneData123,
  configuratorData124, layoutData124, profileData124, sceneData124,
  configuratorData3, layoutData3, profileData3, sceneData3,
  configuratorData50, layoutData50, profileData50, sceneData50,

  configuratorData420, layoutData420, profileData420, sceneData420, //15 - Stationary
  configuratorData421, layoutData421, profileData421, sceneData421, //15 - Swivel

  configuratorData422, layoutData422, profileData422, sceneData422, //14 - Stationary
  configuratorData423, layoutData423, profileData423, sceneData423, //14 - Swivel

  configuratorData425, layoutData425, profileData425, sceneData425, 
} from "./upholsteryChairInfo";

import { 
  configuratorData102, layoutData102, profileData102, sceneData102,
  configuratorData103, layoutData103, profileData103, sceneData103,
  configuratorData104, layoutData104, profileData104, sceneData104,
  configuratorData108, layoutData108, profileData108, sceneData108,
  configuratorData109, layoutData109, profileData109, sceneData109,
  configuratorData149, layoutData149, profileData149, sceneData149,
  configuratorData150, layoutData150, profileData150, sceneData150,
  configuratorData151, layoutData151, profileData151, sceneData151,
  configuratorData152, layoutData152, profileData152, sceneData152,
  configuratorData144, layoutData144, profileData144, sceneData144,
  configuratorData145, layoutData145, profileData145, sceneData145,
  configuratorData153, layoutData153, profileData153, sceneData153,
  configuratorData154, layoutData154, profileData154, sceneData154,
  configuratorData155, layoutData155, profileData155, sceneData155,
  configuratorData156, layoutData156, profileData156, sceneData156,
  configuratorData157, layoutData157, profileData157, sceneData157,
  configuratorData160, layoutData160, profileData160, sceneData160,
  configuratorData161, layoutData161, profileData161, sceneData161,
  configuratorData163, layoutData163, profileData163, sceneData163,
  configuratorData164, layoutData164, profileData164, sceneData164,
  configuratorData165, layoutData165, profileData165, sceneData165,
  configuratorData166, layoutData166, profileData166, sceneData166,
  configuratorData167, layoutData167, profileData167, sceneData167,
  configuratorData176, layoutData176, profileData176, sceneData176,
  configuratorData179, layoutData179, profileData179, sceneData179,
  configuratorData180, layoutData180, profileData180, sceneData180,
  configuratorData181, layoutData181, profileData181, sceneData181,
  configuratorData182, layoutData182, profileData182, sceneData182,
  configuratorData183, layoutData183, profileData183, sceneData183,
  configuratorData184, layoutData184, profileData184, sceneData184,
  configuratorData185, layoutData185, profileData185, sceneData185,
  configuratorData186, layoutData186, profileData186, sceneData186,
  configuratorData187, layoutData187, profileData187, sceneData187,
  configuratorData188, layoutData188, profileData188, sceneData188,
  configuratorData189, layoutData189, profileData189, sceneData189,
  configuratorData190, layoutData190, profileData190, sceneData190,
  configuratorData191, layoutData191, profileData191, sceneData191,
  configuratorData195, layoutData195, profileData195, sceneData195,
  configuratorData196, layoutData196, profileData196, sceneData196,
  configuratorData197, layoutData197, profileData197, sceneData197,
  configuratorData199, layoutData199, profileData199, sceneData199,
  configuratorData200, layoutData200, profileData200, sceneData200,
  configuratorData201, layoutData201, profileData201, sceneData201,
  configuratorData202, layoutData202, profileData202, sceneData202,
  configuratorData203, layoutData203, profileData203, sceneData203,
  configuratorData205, layoutData205, profileData205, sceneData205,
  configuratorData206, layoutData206, profileData206, sceneData206,
  configuratorData207, layoutData207, profileData207, sceneData207,
  configuratorData208, layoutData208, profileData208, sceneData208,
  configuratorData209, layoutData209, profileData209, sceneData209,
  configuratorData210, layoutData210, profileData210, sceneData210,
  configuratorData211, layoutData211, profileData211, sceneData211,
  configuratorData212, layoutData212, profileData212, sceneData212,
  configuratorData213, layoutData213, profileData213, sceneData213,
  configuratorData214, layoutData214, profileData214, sceneData214,
  configuratorData215, layoutData215, profileData215, sceneData215,
  configuratorData216, layoutData216, profileData216, sceneData216,
  configuratorData217, layoutData217, profileData217, sceneData217,
  configuratorData225, layoutData225, profileData225, sceneData225,
  configuratorData226, layoutData226, profileData226, sceneData226,
  configuratorData227, layoutData227, profileData227, sceneData227,
  configuratorData192, layoutData192, profileData192, sceneData192,
  configuratorData193, layoutData193, profileData193, sceneData193,
  configuratorData95, layoutData95, profileData95, sceneData95,
  configuratorData96, layoutData96, profileData96, sceneData96,
  configuratorData97, layoutData97, profileData97, sceneData97,
  configuratorData105, layoutData105, profileData105, sceneData105,
  configuratorData106, layoutData106, profileData106, sceneData106,
  configuratorData107, layoutData107, profileData107, sceneData107,
  configuratorData110, layoutData110, profileData110, sceneData110,
  configuratorData146, layoutData146, profileData146, sceneData146,
  configuratorData168, layoutData168, profileData168, sceneData168,
  configuratorData171, layoutData171, profileData171, sceneData171,
  configuratorData172, layoutData172, profileData172, sceneData172,
  configuratorData173, layoutData173, profileData173, sceneData173,
  configuratorData177, layoutData177, profileData177, sceneData177,
  configuratorData178, layoutData178, profileData178, sceneData178,
  configuratorData194, layoutData194, profileData194, sceneData194,
  configuratorData143, layoutData143, profileData143, sceneData143,
  configuratorData148, layoutData148, profileData148, sceneData148,
  configuratorData141, layoutData141, profileData141, sceneData141,
  configuratorData140, layoutData140, profileData140, sceneData140,
  configuratorData147, layoutData147, profileData147, sceneData147,
 } from "./woodenProductsInfo";

 import { 
  configuratorData204, layoutData204, profileData204, sceneData204,
  configuratorData198, layoutData198, profileData198, sceneData198,
  configuratorData130, layoutData130, profileData130, sceneData130,
  configuratorData91, layoutData91, profileData91, sceneData91,
  configuratorData26, layoutData26, profileData26, sceneData26,
  configuratorData19, layoutData19, profileData19, sceneData19,
  configuratorData46, layoutData46, profileData46, sceneData46,
  configuratorData7, layoutData7, profileData7, sceneData7,
  configuratorData221, layoutData221, profileData221, sceneData221,
  configuratorData82, layoutData82, profileData82, sceneData82,
  configuratorData71, layoutData71, profileData71, sceneData71,
  configuratorData83, layoutData83, profileData83, sceneData83,
  configuratorData162, layoutData162, profileData162, sceneData162,
  configuratorData63, layoutData63, profileData63, sceneData63,
  configuratorData40, layoutData40, profileData40, sceneData40,
  configuratorData41, layoutData41, profileData41, sceneData41,
  configuratorData42, layoutData42, profileData42, sceneData42,
  configuratorData59, layoutData59, profileData59, sceneData59,
  configuratorData43, layoutData43, profileData43, sceneData43,
  configuratorData44, layoutData44, profileData44, sceneData44,
  configuratorData45, layoutData45, profileData45, sceneData45,
  configuratorData11, layoutData11, profileData11, sceneData11,
  configuratorData65, layoutData65, profileData65, sceneData65,
  configuratorData20, layoutData20, profileData20, sceneData20,
  configuratorData52, layoutData52, profileData52, sceneData52,
  configuratorData80, layoutData80, profileData80, sceneData80,
  configuratorData79, layoutData79, profileData79, sceneData79,
  configuratorData174, layoutData174, profileData174, sceneData174,
  configuratorData128, layoutData128, profileData128, sceneData128,
  configuratorData129, layoutData129, profileData129, sceneData129,
  configuratorData285, layoutData285, profileData285, sceneData285,
  configuratorData286, layoutData286, profileData286, sceneData286,
  configuratorData287, layoutData287, profileData287, sceneData287,
  configuratorData288, layoutData288, profileData288, sceneData288,
  configuratorData289, layoutData289, profileData289, sceneData289,
  configuratorData290, layoutData290, profileData290, sceneData290,
  configuratorData291, layoutData291, profileData291, sceneData291,
  configuratorData292, layoutData292, profileData292, sceneData292,
  configuratorData293, layoutData293, profileData293, sceneData293,
  configuratorData294, layoutData294, profileData294, sceneData294,
  configuratorData295, layoutData295, profileData295, sceneData295,
  configuratorData296, layoutData296, profileData296, sceneData296,
  configuratorData297, layoutData297, profileData297, sceneData297,
  configuratorData298, layoutData298, profileData298, sceneData298,
  configuratorData299, layoutData299, profileData299, sceneData299,
  configuratorData300, layoutData300, profileData300, sceneData300,
  configuratorData301, layoutData301, profileData301, sceneData301,
  configuratorData1, layoutData1, profileData1, sceneData1,
  configuratorData302, layoutData302, profileData302, sceneData302,
  configuratorData303, layoutData303, profileData303, sceneData303,
  configuratorData304, layoutData304, profileData304, sceneData304,
  configuratorData305, layoutData305, profileData305, sceneData305,
  configuratorData306, layoutData306, profileData306, sceneData306,
  configuratorData307, layoutData307, profileData307, sceneData307,
  configuratorData308, layoutData308, profileData308, sceneData308,
  configuratorData309, layoutData309, profileData309, sceneData309,
  configuratorData310, layoutData310, profileData310, sceneData310,
  configuratorData2, layoutData2, profileData2, sceneData2,
  configuratorData115, layoutData115, profileData115, sceneData115,
  configuratorData117, layoutData117, profileData117, sceneData117,
  configuratorData169, layoutData169, profileData169, sceneData169,
  configuratorData311, layoutData311, profileData311, sceneData311,
  configuratorData312, layoutData312, profileData312, sceneData312,
  configuratorData313, layoutData313, profileData313, sceneData313,
  configuratorData314, layoutData314, profileData314, sceneData314,
  configuratorData315, layoutData315, profileData315, sceneData315,
  configuratorData316, layoutData316, profileData316, sceneData316,
  configuratorData319, layoutData319, profileData319, sceneData319,
  configuratorData320, layoutData320, profileData320, sceneData320,
  configuratorData321, layoutData321, profileData321, sceneData321,
  configuratorData323, layoutData323, profileData323, sceneData323,
  configuratorData325, layoutData325, profileData325, sceneData325,
  configuratorData327, layoutData327, profileData327, sceneData327,
  configuratorData330, layoutData330, profileData330, sceneData330,
  configuratorData331, layoutData331, profileData331, sceneData331,
  configuratorData317, layoutData317, profileData317, sceneData317,
  configuratorData318, layoutData318, profileData318, sceneData318,
  configuratorData322, layoutData322, profileData322, sceneData322,
  configuratorData324, layoutData324, profileData324, sceneData324,
  configuratorData326, layoutData326, profileData326, sceneData326,
  configuratorData328, layoutData328, profileData328, sceneData328,
  configuratorData329, layoutData329, profileData329, sceneData329,
  configuratorData332, layoutData332, profileData332, sceneData332,
  configuratorData333, layoutData333, profileData333, sceneData333,
  configuratorData334, layoutData334, profileData334, sceneData334,
  configuratorData335, layoutData335, profileData335, sceneData335,
  configuratorData336, layoutData336, profileData336, sceneData336,
  configuratorData337, layoutData337, profileData337, sceneData337,
  configuratorData85, layoutData85, profileData85, sceneData85,
  configuratorData87, layoutData87, profileData87, sceneData87,
  configuratorData93, layoutData93, profileData93, sceneData93,
  configuratorData223, layoutData223, profileData223, sceneData223,
  configuratorData90, layoutData90, profileData90, sceneData90,
  configuratorData81, layoutData81, profileData81, sceneData81,
  configuratorData84, layoutData84, profileData84, sceneData84,
  configuratorData338, layoutData338, profileData338, sceneData338,
  configuratorData339, layoutData339, profileData339, sceneData339,
  configuratorData340, layoutData340, profileData340, sceneData340,
  configuratorData341, layoutData341, profileData341, sceneData341,
  configuratorData342, layoutData342, profileData342, sceneData342,
  configuratorData343, layoutData343, profileData343, sceneData343,
  configuratorData344, layoutData344, profileData344, sceneData344,
  configuratorData345, layoutData345, profileData345, sceneData345,
  configuratorData346, layoutData346, profileData346, sceneData346,
  configuratorData347, layoutData347, profileData347, sceneData347,
  configuratorData348, layoutData348, profileData348, sceneData348,
  configuratorData349, layoutData349, profileData349, sceneData349,
  configuratorData350, layoutData350, profileData350, sceneData350,
  configuratorData351, layoutData351, profileData351, sceneData351,
  configuratorData352, layoutData352, profileData352, sceneData352,
  configuratorData353, layoutData353, profileData353, sceneData353,
  configuratorData354, layoutData354, profileData354, sceneData354,
  configuratorData355, layoutData355, profileData355, sceneData355,
  configuratorData369, layoutData369, profileData369, sceneData369,
  configuratorData370, layoutData370, profileData370, sceneData370,
  configuratorData371, layoutData371, profileData371, sceneData371,
  configuratorData372, layoutData372, profileData372, sceneData372,
  configuratorData373, layoutData373, profileData373, sceneData373,
  configuratorData374, layoutData374, profileData374, sceneData374,
  configuratorData381, layoutData381, profileData381, sceneData381,
  configuratorData382, layoutData382, profileData382, sceneData382,
  configuratorData383, layoutData383, profileData383, sceneData383,
  configuratorData384, layoutData384, profileData384, sceneData384,
  configuratorData385, layoutData385, profileData385, sceneData385,
  configuratorData386, layoutData386, profileData386, sceneData386,
  configuratorData387, layoutData387, profileData387, sceneData387,
  configuratorData388, layoutData388, profileData388, sceneData388,
  configuratorData389, layoutData389, profileData389, sceneData389,
  configuratorData390, layoutData390, profileData390, sceneData390,
  configuratorData391, layoutData391, profileData391, sceneData391,
  configuratorData392, layoutData392, profileData392, sceneData392,
  configuratorData393, layoutData393, profileData393, sceneData393,
  configuratorData394, layoutData394, profileData394, sceneData394,
  configuratorData395, layoutData395, profileData395, sceneData395,
  configuratorData396, layoutData396, profileData396, sceneData396,
  configuratorData397, layoutData397, profileData397, sceneData397,
  configuratorData398, layoutData398, profileData398, sceneData398,
  configuratorData399, layoutData399, profileData399, sceneData399,
  configuratorData400, layoutData400, profileData400, sceneData400,
  configuratorData401, layoutData401, profileData401, sceneData401,
  configuratorData402, layoutData402, profileData402, sceneData402,
  configuratorData403, layoutData403, profileData403, sceneData403,
  configuratorData404, layoutData404, profileData404, sceneData404,
  configuratorData379, layoutData379, profileData379, sceneData379,
  configuratorData380, layoutData380, profileData380, sceneData380,
  configuratorData361, layoutData361, profileData361, sceneData361,
  configuratorData362, layoutData362, profileData362, sceneData362,
  configuratorData365, layoutData365, profileData365, sceneData365,
  configuratorData366, layoutData366, profileData366, sceneData366,
  configuratorData377, layoutData377, profileData377, sceneData377,
  configuratorData378, layoutData378, profileData378, sceneData378,
  configuratorData405, layoutData405, profileData405, sceneData405,
  configuratorData406, layoutData406, profileData406, sceneData406,
  configuratorData363, layoutData363, profileData363, sceneData363,
  configuratorData364, layoutData364, profileData364, sceneData364,
  configuratorData367, layoutData367, profileData367, sceneData367,
  configuratorData368, layoutData368, profileData368, sceneData368,
  configuratorData375, layoutData375, profileData375, sceneData375,
  configuratorData376, layoutData376, profileData376, sceneData376,
  configuratorData218, layoutData218, profileData218, sceneData218,
  configuratorData88, layoutData88, profileData88, sceneData88,
  configuratorData224, layoutData224, profileData224, sceneData224,
  configuratorData407, layoutData407, profileData407, sceneData407,
  configuratorData408, layoutData408, profileData408, sceneData408,
  configuratorData409, layoutData409, profileData409, sceneData409,
  configuratorData410, layoutData410, profileData410, sceneData410,
  configuratorData411, layoutData411, profileData411, sceneData411,
  configuratorData136, layoutData136, profileData136, sceneData136,

  configuratorData412, layoutData412, profileData412, sceneData412, //403 - size 60
  configuratorData413, layoutData413, profileData413, sceneData413, //403 - size 72
  configuratorData414, layoutData414, profileData414, sceneData414, //403 - size 84
  configuratorData415, layoutData415, profileData415, sceneData415, //403 - size 96

  configuratorData416, layoutData416, profileData416, sceneData416, //404 - size 60
  configuratorData417, layoutData417, profileData417, sceneData417, //404 - size 72
  configuratorData418, layoutData418, profileData418, sceneData418, //404 - size 84
  configuratorData419, layoutData419, profileData419, sceneData419, //404 - size 96

  configuratorData424, layoutData424, profileData424, sceneData424,
  configuratorData426, layoutData426, profileData426, sceneData426,

 } from "./multipleConfiguratorInfo";

export const CONFIGURATOR_UUID = [
    '136',
    '363','367','369','371','373','375','381','383','385','387','389','391','393','395','397','399','401','403','379','361','365','377','405',  //painted
    '364','368','370','372','374','376','382','384','386','388','390','392','394','396','398','400','402','404','380','362','366','378','406', //Wood
    '218','88','224','407','408','409','410','411',
    '85','87','93','223','90','81','84','338','339','340','341',
    '342','343','344','345','346','347','348','349','350','351','352','353','354','355',
    '317','318','322','324','326','328','329','332','333','334','335','336','337',
    '315','316','319','320','321','323','325','327','330','331',
    '115','117','169','311','312','313','314',
    '13','29','21','5','53','9','12','10','8','24',  // Upholstery Chairs
    '102','103','104','108','109','149','151','152', // Wooden Products
    '153','154','155','156','157','160','161','163', // Wooden Products
    '164','165','166','167','176','179','180','181', // Wooden Products
    '182','183','184','185','186','188','189','190', // Wooden Products
    '191','195','196','197','199','200','202','201', // Wooden Products
    '203','205','206','207','208','209','210','211', // Wooden Products
    '212','214','215','216','217','225','226','227', // Wooden Products
    '192','193','187','213','95', '96','97','105', // Wooden Products
    '106','107','110','168','171','173','146','172', // Wooden Products
    '177','178','194','143','141','140','147','148', // Wooden Products '148'
    '144','145','222','204','198','91','26','19','46', // priority to be added
    '7','221','82','71','83','162','63','130','150',   // priority to be added
    '76','68','64','57','75','67','6','284','14','15',  // Upholstery
    '121','113','73','72','49','62','25','51','58','69',// Upholstery
    '23','60','132','27','77','17','123','124','3','50', // Upholstery
    '40','41','42','59','43','44','45','11','65','20','52', // Multiple Configurator
    '80','79','128','174','129',
    '285','286', '287', '288','289','290','291','292',// Not availble on shopify
    '293','294','295','296','297','298','299','300','301', // Not availble on shopify
    '302','303','304','305','306','307','308','309','310', // Not availble on shopify
    '1','2', // Multiple Configurator

    '412','413','414','415', // 403 - size 60,72,84,96
    '416','417','418','419', // 404 - size 60,72,84,96

    '420','421', //15
    '422','423', //14

    '424','425',
    
    '426'
];

//Missing UUID list
// 4,
// 16, 18, 22, 28,
// 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
// 47, 48,
// 54, 55, 56,
// 61, 66, 70, 74, 78,
// 86, 89, 92, 94, ̰
// 98, 99, 100, 101,
// 111, 112, 114, 116, 118, 119, 120, 122,
// 125, 126, 127, 131, 133, 134, 135,
// 137, 138, 139, 142,
// 158, 159, 170, 175,
// 219, 220,
// 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239,
// 240, 241, 242, 243, 244, 245, 246, 247, 248, 249,
// 250, 251, 252, 253, 254, 255, 256, 257, 258, 259,
// 260, 261, 262, 263, 264, 265, 266, 267, 268, 269,
// 270, 271, 272, 273, 274, 275, 276, 277, 278, 279,
// 280, 281, 282, 283,
// 356, 357, 358, 359, 360

export const WOOD_TOP_UUID = [
  '144','145','95','96','97','105',
  '106','107','110','168','171','173',
  '177','178','194','143','141','140','147',
  '146','172','148',
  '169','343','344','345','346','347','348','336','337',
];

export const NO_CUSHION_UUID = [
  '130','121','113','123','128','129','174',
  '115','117','136',
  '424','426'
];

export const Wood_Knobs = [
  '381','382','383','384','385','386','410','411',
];

export const newWoods = [
  "333","342","343","344","345","346","347","348","349","350","351","355","355","362","364","366","370","372","374","376","378","380","382","384","386","388","390","392","394","396","398","400","402","404","406","408","407","409",'411',
  '416','417','418','419'
];

export const WOODS_TO_APPEND_LAYOUT = [
  "Natural Quarter Sawn White Oak",
  "Matte Glazed White Oak",
  "Hand Planed Bourbon Cherry",
  "Natural Cherry",
  "Natural Maple",
];

// Wood Knobs
export const modelDataMap = {
  136: {
    configurator: configuratorData136,
    layout: layoutData136,
    profile: profileData136,
    scene: sceneData136,
  },
  410: {
    configurator: configuratorData410,
    layout: layoutData410,
    profile: profileData410,
    scene: sceneData410,
  },
  411: {
    configurator: configuratorData411,
    layout: layoutData411,
    profile: profileData411,
    scene: sceneData411,
  },
  407: {
    configurator: configuratorData407,
    layout: layoutData407,
    profile: profileData407,
    scene: sceneData407,
  },
  408: {
    configurator: configuratorData408,
    layout: layoutData408,
    profile: profileData408,
    scene: sceneData408,
  },
  409: {
    configurator: configuratorData409,
    layout: layoutData409,
    profile: profileData409,
    scene: sceneData409,
  },
  224: {
    configurator: configuratorData224,
    layout: layoutData224,
    profile: profileData224,
    scene: sceneData224,
  },
  88: {
    configurator: configuratorData88,
    layout: layoutData88,
    profile: profileData88,
    scene: sceneData88,
  },
  218: {
    configurator: configuratorData218,
    layout: layoutData218,
    profile: profileData218,
    scene: sceneData218,
  },
  375: {
    configurator: configuratorData375,
    layout: layoutData375,
    profile: profileData375,
    scene: sceneData375,
  },
  376: {
    configurator: configuratorData376,
    layout: layoutData376,
    profile: profileData376,
    scene: sceneData376,
  },
   367: {
    configurator: configuratorData367,
    layout: layoutData367,
    profile: profileData367,
    scene: sceneData367,
  },
  368: {
    configurator: configuratorData368,
    layout: layoutData368,
    profile: profileData368,
    scene: sceneData368,
  },
  363: {
    configurator: configuratorData363,
    layout: layoutData363,
    profile: profileData363,
    scene: sceneData363,
  },
  364: {
    configurator: configuratorData364,
    layout: layoutData364,
    profile: profileData364,
    scene: sceneData364,
  },
   405: {
    configurator: configuratorData405,
    layout: layoutData405,
    profile: profileData405,
    scene: sceneData405,
  },
  406: {
    configurator: configuratorData406,
    layout: layoutData406,
    profile: profileData406,
    scene: sceneData406,
  },
   377: {
    configurator: configuratorData377,
    layout: layoutData377,
    profile: profileData377,
    scene: sceneData377,
  },
  378: {
    configurator: configuratorData378,
    layout: layoutData378,
    profile: profileData378,
    scene: sceneData378,
  },
   365: {
    configurator: configuratorData365,
    layout: layoutData365,
    profile: profileData365,
    scene: sceneData365,
  },
  366: {
    configurator: configuratorData366,
    layout: layoutData366,
    profile: profileData366,
    scene: sceneData366,
  },
  361: {
    configurator: configuratorData361,
    layout: layoutData361,
    profile: profileData361,
    scene: sceneData361,
  },
  362: {
    configurator: configuratorData362,
    layout: layoutData362,
    profile: profileData362,
    scene: sceneData362,
  },
  379: {
    configurator: configuratorData379,
    layout: layoutData379,
    profile: profileData379,
    scene: sceneData379,
  },
  380: {
    configurator: configuratorData380,
    layout: layoutData380,
    profile: profileData380,
    scene: sceneData380,
  },
  403: {
    configurator: configuratorData403,
    layout: layoutData403,
    profile: profileData403,
    scene: sceneData403,
  },
  412: {
    configurator: configuratorData412,
    layout: layoutData412,
    profile: profileData412,
    scene: sceneData412,
  },
  413: {
    configurator: configuratorData413,
    layout: layoutData413,
    profile: profileData413,
    scene: sceneData413,
  },
  414: {
    configurator: configuratorData414,
    layout: layoutData414,
    profile: profileData414,
    scene: sceneData414,
  },
  415: {
    configurator: configuratorData415,
    layout: layoutData415,
    profile: profileData415,
    scene: sceneData415,
  },
  404: {
    configurator: configuratorData404,
    layout: layoutData404,
    profile: profileData404,
    scene: sceneData404,
  },
  416: {
    configurator: configuratorData416,
    layout: layoutData416,
    profile: profileData416,
    scene: sceneData416,
  },
  417: {
    configurator: configuratorData417,
    layout: layoutData417,
    profile: profileData417,
    scene: sceneData417,
  },
  418: {
    configurator: configuratorData418,
    layout: layoutData418,
    profile: profileData418,
    scene: sceneData418,
  },
  419: {
    configurator: configuratorData419,
    layout: layoutData419,
    profile: profileData419,
    scene: sceneData419,
  },
  401: {
    configurator: configuratorData401,
    layout: layoutData401,
    profile: profileData401,
    scene: sceneData401,
  },
  402: {
    configurator: configuratorData402,
    layout: layoutData402,
    profile: profileData402,
    scene: sceneData402,
  },
  399: {
    configurator: configuratorData399,
    layout: layoutData399,
    profile: profileData399,
    scene: sceneData399,
  },
  400: {
    configurator: configuratorData400,
    layout: layoutData400,
    profile: profileData400,
    scene: sceneData400,
  },
  397: {
    configurator: configuratorData397,
    layout: layoutData397,
    profile: profileData397,
    scene: sceneData397,
  },
  398: {
    configurator: configuratorData398,
    layout: layoutData398,
    profile: profileData398,
    scene: sceneData398,
  },
  395: {
    configurator: configuratorData395,
    layout: layoutData395,
    profile: profileData395,
    scene: sceneData395,
  },
  396: {
    configurator: configuratorData396,
    layout: layoutData396,
    profile: profileData396,
    scene: sceneData396,
  },
  393: {
    configurator: configuratorData393,
    layout: layoutData393,
    profile: profileData393,
    scene: sceneData393,
  },
  394: {
    configurator: configuratorData394,
    layout: layoutData394,
    profile: profileData394,
    scene: sceneData394,
  },
  391: {
    configurator: configuratorData391,
    layout: layoutData391,
    profile: profileData391,
    scene: sceneData391,
  },
  392: {
    configurator: configuratorData392,
    layout: layoutData392,
    profile: profileData392,
    scene: sceneData392,
  },
  389: {
    configurator: configuratorData389,
    layout: layoutData389,
    profile: profileData389,
    scene: sceneData389,
  },
  390: {
    configurator: configuratorData390,
    layout: layoutData390,
    profile: profileData390,
    scene: sceneData390,
  },
  387: {
    configurator: configuratorData387,
    layout: layoutData387,
    profile: profileData387,
    scene: sceneData387,
  },
  388: {
    configurator: configuratorData388,
    layout: layoutData388,
    profile: profileData388,
    scene: sceneData388,
  },
  385: {
    configurator: configuratorData385,
    layout: layoutData385,
    profile: profileData385,
    scene: sceneData385,
  },
  386: {
    configurator: configuratorData386,
    layout: layoutData386,
    profile: profileData386,
    scene: sceneData386,
  },
  383: {
    configurator: configuratorData383,
    layout: layoutData383,
    profile: profileData383,
    scene: sceneData383,
  },
  384: {
    configurator: configuratorData384,
    layout: layoutData384,
    profile: profileData384,
    scene: sceneData384,
  },
  381: {
    configurator: configuratorData381,
    layout: layoutData381,
    profile: profileData381,
    scene: sceneData381,
  },
  382: {
    configurator: configuratorData382,
    layout: layoutData382,
    profile: profileData382,
    scene: sceneData382,
  },
  373: {
    configurator: configuratorData373,
    layout: layoutData373,
    profile: profileData373,
    scene: sceneData373,
  },
  374: {
    configurator: configuratorData374,
    layout: layoutData374,
    profile: profileData374,
    scene: sceneData374,
  },
  371: {
    configurator: configuratorData371,
    layout: layoutData371,
    profile: profileData371,
    scene: sceneData371,
  },
  372: {
    configurator: configuratorData372,
    layout: layoutData372,
    profile: profileData372,
    scene: sceneData372,
  },
  369: {
    configurator: configuratorData369,
    layout: layoutData369,
    profile: profileData369,
    scene: sceneData369,
  },
  370: {
    configurator: configuratorData370,
    layout: layoutData370,
    profile: profileData370,
    scene: sceneData370,
  },
  355: {
    configurator: configuratorData355,
    layout: layoutData355,
    profile: profileData355,
    scene: sceneData355,
  },
  354: {
    configurator: configuratorData354,
    layout: layoutData354,
    profile: profileData354,
    scene: sceneData354,
  },
  353: {
    configurator: configuratorData353,
    layout: layoutData353,
    profile: profileData353,
    scene: sceneData353,
  },
  352: {
    configurator: configuratorData352,
    layout: layoutData352,
    profile: profileData352,
    scene: sceneData352,
  },
  351: {
    configurator: configuratorData351,
    layout: layoutData351,
    profile: profileData351,
    scene: sceneData351,
  },
  350: {
    configurator: configuratorData350,
    layout: layoutData350,
    profile: profileData350,
    scene: sceneData350,
  },
  349: {
    configurator: configuratorData349,
    layout: layoutData349,
    profile: profileData349,
    scene: sceneData349,
  },
  348: {
    configurator: configuratorData348,
    layout: layoutData348,
    profile: profileData348,
    scene: sceneData348,
  },
  347: {
    configurator: configuratorData347,
    layout: layoutData347,
    profile: profileData347,
    scene: sceneData347,
  },
  346: {
    configurator: configuratorData346,
    layout: layoutData346,
    profile: profileData346,
    scene: sceneData346,
  },
  345: {
    configurator: configuratorData345,
    layout: layoutData345,
    profile: profileData345,
    scene: sceneData345,
  },
  344: {
    configurator: configuratorData344,
    layout: layoutData344,
    profile: profileData344,
    scene: sceneData344,
  },
  343: {
    configurator: configuratorData343,
    layout: layoutData343,
    profile: profileData343,
    scene: sceneData343,
  },
  342: {
    configurator: configuratorData342,
    layout: layoutData342,
    profile: profileData342,
    scene: sceneData342,
  },
  341: {
    configurator: configuratorData341,
    layout: layoutData341,
    profile: profileData341,
    scene: sceneData341,
  },
  340: {
    configurator: configuratorData340,
    layout: layoutData340,
    profile: profileData340,
    scene: sceneData340,
  },
  339: {
    configurator: configuratorData339,
    layout: layoutData339,
    profile: profileData339,
    scene: sceneData339,
  },
  338: {
    configurator: configuratorData338,
    layout: layoutData338,
    profile: profileData338,
    scene: sceneData338,
  },
  84: {
    configurator: configuratorData84,
    layout: layoutData84,
    profile: profileData84,
    scene: sceneData84,
  },
  81: {
    configurator: configuratorData81,
    layout: layoutData81,
    profile: profileData81,
    scene: sceneData81,
  },
  90: {
    configurator: configuratorData90,
    layout: layoutData90,
    profile: profileData90,
    scene: sceneData90,
  },
  223: {
    configurator: configuratorData223,
    layout: layoutData223,
    profile: profileData223,
    scene: sceneData223,
  },
  93: {
    configurator: configuratorData93,
    layout: layoutData93,
    profile: profileData93,
    scene: sceneData93,
  },
  87: {
    configurator: configuratorData87,
    layout: layoutData87,
    profile: profileData87,
    scene: sceneData87,
  },
  85: {
    configurator: configuratorData85,
    layout: layoutData85,
    profile: profileData85,
    scene: sceneData85,
  },
  333: {
    configurator: configuratorData333,
    layout: layoutData333,
    profile: profileData333,
    scene: sceneData333,
  },
  334: {
    configurator: configuratorData334,
    layout: layoutData334,
    profile: profileData334,
    scene: sceneData334,
  },
  335: {
    configurator: configuratorData335,
    layout: layoutData335,
    profile: profileData335,
    scene: sceneData335,
  },
  336: {
    configurator: configuratorData336,
    layout: layoutData336,
    profile: profileData336,
    scene: sceneData336,
  },
  337: {
    configurator: configuratorData337,
    layout: layoutData337,
    profile: profileData337,
    scene: sceneData337,
  },
  322: {
    configurator: configuratorData322,
    layout: layoutData322,
    profile: profileData322,
    scene: sceneData322,
  },
  322: {
    configurator: configuratorData322,
    layout: layoutData322,
    profile: profileData322,
    scene: sceneData322,
  },
  324: {
    configurator: configuratorData324,
    layout: layoutData324,
    profile: profileData324,
    scene: sceneData324,
  },
  326: {
    configurator: configuratorData326,
    layout: layoutData326,
    profile: profileData326,
    scene: sceneData326,
  },
  328: {
    configurator: configuratorData328,
    layout: layoutData328,
    profile: profileData328,
    scene: sceneData328,
  },
  329: {
    configurator: configuratorData329,
    layout: layoutData329,
    profile: profileData329,
    scene: sceneData329,
  },
  332: {
    configurator: configuratorData332,
    layout: layoutData332,
    profile: profileData332,
    scene: sceneData332,
  },
  317: {
    configurator: configuratorData317,
    layout: layoutData317,
    profile: profileData317,
    scene: sceneData317,
  },
  318: {
    configurator: configuratorData318,
    layout: layoutData318,
    profile: profileData318,
    scene: sceneData318,
  },
  330: {
    configurator: configuratorData330,
    layout: layoutData330,
    profile: profileData330,
    scene: sceneData330,
  },
  331: {
    configurator: configuratorData331,
    layout: layoutData331,
    profile: profileData331,
    scene: sceneData331,
  },
  327: {
    configurator: configuratorData327,
    layout: layoutData327,
    profile: profileData327,
    scene: sceneData327,
  },
  325: {
    configurator: configuratorData325,
    layout: layoutData325,
    profile: profileData325,
    scene: sceneData325,
  },
  323: {
    configurator: configuratorData323,
    layout: layoutData323,
    profile: profileData323,
    scene: sceneData323,
  },
  321: {
    configurator: configuratorData321,
    layout: layoutData321,
    profile: profileData321,
    scene: sceneData321,
  },
  320: {
    configurator: configuratorData320,
    layout: layoutData320,
    profile: profileData320,
    scene: sceneData320,
  },
  319: {
    configurator: configuratorData319,
    layout: layoutData319,
    profile: profileData319,
    scene: sceneData319,
  },
  315: {
    configurator: configuratorData315,
    layout: layoutData315,
    profile: profileData315,
    scene: sceneData315,
  },
  316: {
    configurator: configuratorData316,
    layout: layoutData316,
    profile: profileData316,
    scene: sceneData316,
  },
  115: {
    configurator: configuratorData115,
    layout: layoutData115,
    profile: profileData115,
    scene: sceneData115,
  },
  117: {
    configurator: configuratorData117,
    layout: layoutData117,
    profile: profileData117,
    scene: sceneData117,
  },
  169: {
    configurator: configuratorData169,
    layout: layoutData169,
    profile: profileData169,
    scene: sceneData169,
  },
  311: {
    configurator: configuratorData311,
    layout: layoutData311,
    profile: profileData311,
    scene: sceneData311,
  },
  312: {
    configurator: configuratorData312,
    layout: layoutData312,
    profile: profileData312,
    scene: sceneData312,
  },
  313: {
    configurator: configuratorData313,
    layout: layoutData313,
    profile: profileData313,
    scene: sceneData313,
  },
  314: {
    configurator: configuratorData314,
    layout: layoutData314,
    profile: profileData314,
    scene: sceneData314,
  },
  310: {
    configurator: configuratorData310,
    layout: layoutData310,
    profile: profileData310,
    scene: sceneData310,
  },
  309: {
    configurator: configuratorData309,
    layout: layoutData309,
    profile: profileData309,
    scene: sceneData309,
  },
  308: {
    configurator: configuratorData308,
    layout: layoutData308,
    profile: profileData308,
    scene: sceneData308,
  },
  307: {
    configurator: configuratorData307,
    layout: layoutData307,
    profile: profileData307,
    scene: sceneData307,
  },
  306: {
    configurator: configuratorData306,
    layout: layoutData306,
    profile: profileData306,
    scene: sceneData306,
  },
  305: {
    configurator: configuratorData305,
    layout: layoutData305,
    profile: profileData305,
    scene: sceneData305,
  },
  304: {
    configurator: configuratorData304,
    layout: layoutData304,
    profile: profileData304,
    scene: sceneData304,
  },
  303: {
    configurator: configuratorData303,
    layout: layoutData303,
    profile: profileData303,
    scene: sceneData303,
  },
  302: {
    configurator: configuratorData302,
    layout: layoutData302,
    profile: profileData302,
    scene: sceneData302,
  },
  1: {
    configurator: configuratorData1,
    layout: layoutData1,
    profile: profileData1,
    scene: sceneData1,
  },
  2: {
    configurator: configuratorData2,
    layout: layoutData2,
    profile: profileData2,
    scene: sceneData2,
  },
   301: {
    configurator: configuratorData301,
    layout: layoutData301,
    profile: profileData301,
    scene: sceneData301,
  },
   300: {
    configurator: configuratorData300,
    layout: layoutData300,
    profile: profileData300,
    scene: sceneData300,
  },
   299: {
    configurator: configuratorData299,
    layout: layoutData299,
    profile: profileData299,
    scene: sceneData299,
  },
   298: {
    configurator: configuratorData298,
    layout: layoutData298,
    profile: profileData298,
    scene: sceneData298,
  },
   297: {
    configurator: configuratorData297,
    layout: layoutData297,
    profile: profileData297,
    scene: sceneData297,
  },
  296: {
    configurator: configuratorData296,
    layout: layoutData296,
    profile: profileData296,
    scene: sceneData296,
  },
  295: {
    configurator: configuratorData295,
    layout: layoutData295,
    profile: profileData295,
    scene: sceneData295,
  },
  294: {
    configurator: configuratorData294,
    layout: layoutData294,
    profile: profileData294,
    scene: sceneData294,
  },
   293: {
    configurator: configuratorData293,
    layout: layoutData293,
    profile: profileData293,
    scene: sceneData293,
  },
   292: {
    configurator: configuratorData292,
    layout: layoutData292,
    profile: profileData292,
    scene: sceneData292,
  },
   291: {
    configurator: configuratorData291,
    layout: layoutData291,
    profile: profileData291,
    scene: sceneData291,
  },
   290: {
    configurator: configuratorData290,
    layout: layoutData290,
    profile: profileData290,
    scene: sceneData290,
  },
  289: {
    configurator: configuratorData289,
    layout: layoutData289,
    profile: profileData289,
    scene: sceneData289,
  },
  288: {
    configurator: configuratorData288,
    layout: layoutData288,
    profile: profileData288,
    scene: sceneData288,
  },
  287: {
    configurator: configuratorData287,
    layout: layoutData287,
    profile: profileData287,
    scene: sceneData287,
  },
  286: {
    configurator: configuratorData286,
    layout: layoutData286,
    profile: profileData286,
    scene: sceneData286,
  },
  285: {
    configurator: configuratorData285,
    layout: layoutData285,
    profile: profileData285,
    scene: sceneData285,
  },
  40: {
    configurator: configuratorData40,
    layout: layoutData40,
    profile: profileData40,
    scene: sceneData40,
  },
  41: {
    configurator: configuratorData41,
    layout: layoutData41,
    profile: profileData41,
    scene: sceneData41,
  },
  42: {
    configurator: configuratorData42,
    layout: layoutData42,
    profile: profileData42,
    scene: sceneData42,
  },
  59: {
    configurator: configuratorData59,
    layout: layoutData59,
    profile: profileData59,
    scene: sceneData59,
  },
  43: {
    configurator: configuratorData43,
    layout: layoutData43,
    profile: profileData43,
    scene: sceneData43,
  },
  44: {
    configurator: configuratorData44,
    layout: layoutData44,
    profile: profileData44,
    scene: sceneData44,
  },
  45: {
    configurator: configuratorData45,
    layout: layoutData45,
    profile: profileData45,
    scene: sceneData45,
  },
  11: {
    configurator: configuratorData11,
    layout: layoutData11,
    profile: profileData11,
    scene: sceneData11,
  },
  65: {
    configurator: configuratorData65,
    layout: layoutData65,
    profile: profileData65,
    scene: sceneData65,
  },
  20: {
    configurator: configuratorData20,
    layout: layoutData20,
    profile: profileData20,
    scene: sceneData20,
  },
  52: {
    configurator: configuratorData52,
    layout: layoutData52,
    profile: profileData52,
    scene: sceneData52,
  },
   80: {
    configurator: configuratorData80,
    layout: layoutData80,
    profile: profileData80,
    scene: sceneData80,
  },
  79: {
    configurator: configuratorData79,
    layout: layoutData79,
    profile: profileData79,
    scene: sceneData79,
  },
  174: {
    configurator: configuratorData174,
    layout: layoutData174,
    profile: profileData174,
    scene: sceneData174,
  },
  128: {
    configurator: configuratorData128,
    layout: layoutData128,
    profile: profileData128,
    scene: sceneData128,
  },
  129: {
    configurator: configuratorData129,
    layout: layoutData129,
    profile: profileData129,
    scene: sceneData129,
  },
  // Upholstery Chair Configurator Data starts
  13: {
    configurator: configuratorData13,
    layout: layoutData13,
    profile: profileData13,
    scene: sceneData13,
  },
  29: {
    configurator: configuratorData29,
    layout: layoutData29,
    profile: profileData29,
    scene: sceneData29,
  },
  21: {
    configurator: configuratorData21,
    layout: layoutData21,
    profile: profileData21,
    scene: sceneData21,
  },
  5: {
    configurator: configuratorData5,
    layout: layoutData5,
    profile: profileData5,
    scene: sceneData5,
  },
  53: {
    configurator: configuratorData53,
    layout: layoutData53,
    profile: profileData53,
    scene: sceneData53,
  },
  425: {
    configurator: configuratorData425,
    layout: layoutData425,
    profile: profileData425,
    scene: sceneData425,
  },
  9: {
    configurator: configuratorData9,
    layout: layoutData9,
    profile: profileData9,
    scene: sceneData9,
  },
  12: {
    configurator: configuratorData12,
    layout: layoutData12,
    profile: profileData12,
    scene: sceneData12,
  },
  10: {
    configurator: configuratorData10,
    layout: layoutData10,
    profile: profileData10,
    scene: sceneData10,
  },
  8: {
    configurator: configuratorData8,
    layout: layoutData8,
    profile: profileData8,
    scene: sceneData8,
  },
  24: {
    configurator: configuratorData24,
    layout: layoutData24,
    profile: profileData24,
    scene: sceneData24,
  },
  222: {
    configurator: configuratorData222,
    layout: layoutData222,
    profile: profileData222,
    scene: sceneData222,
  },
  76: {
    configurator: configuratorData76,
    layout: layoutData76,
    profile: profileData76,
    scene: sceneData76,
  },
  68: {
    configurator: configuratorData68,
    layout: layoutData68,
    profile: profileData68,
    scene: sceneData68,
  },
  64: {
    configurator: configuratorData64,
    layout: layoutData64,
    profile: profileData64,
    scene: sceneData64,
  },
  57: {
    configurator: configuratorData57,
    layout: layoutData57,
    profile: profileData57,
    scene: sceneData57,
  },
  75: {
    configurator: configuratorData75,
    layout: layoutData75,
    profile: profileData75,
    scene: sceneData75,
  },
  67: {
    configurator: configuratorData67,
    layout: layoutData67,
    profile: profileData67,
    scene: sceneData67,
  },
  6: {
    configurator: configuratorData6,
    layout: layoutData6,
    profile: profileData6,
    scene: sceneData6,
  },
  284: {
    configurator: configuratorData284,
    layout: layoutData284,
    profile: profileData284,
    scene: sceneData284,
  },
  14: {
    configurator: configuratorData14,
    layout: layoutData14,
    profile: profileData14,
    scene: sceneData14,
  },
  422: {
    configurator: configuratorData422,
    layout: layoutData422,
    profile: profileData422,
    scene: sceneData422,
  },
  423: {
    configurator: configuratorData423,
    layout: layoutData423,
    profile: profileData423,
    scene: sceneData423,
  },
  15: {
    configurator: configuratorData15,
    layout: layoutData15,
    profile: profileData15,
    scene: sceneData15,
  },
  420: {
    configurator: configuratorData420,
    layout: layoutData420,
    profile: profileData420,
    scene: sceneData420,
  },
  421: {
    configurator: configuratorData421,
    layout: layoutData421,
    profile: profileData421,
    scene: sceneData421,
  },
  121: {
    configurator: configuratorData121,
    layout: layoutData121,
    profile: profileData121,
    scene: sceneData121,
  },
  113: {
    configurator: configuratorData113,
    layout: layoutData113,
    profile: profileData113,
    scene: sceneData113,
  },
  73: {
    configurator: configuratorData73,
    layout: layoutData73,
    profile: profileData73,
    scene: sceneData73,
  },
  72: {
    configurator: configuratorData72,
    layout: layoutData72,
    profile: profileData72,
    scene: sceneData72,
  },
  49: {
    configurator: configuratorData49,
    layout: layoutData49,
    profile: profileData49,
    scene: sceneData49,
  },
  62: {
    configurator: configuratorData62,
    layout: layoutData62,
    profile: profileData62,
    scene: sceneData62,
  },
  25: {
    configurator: configuratorData25,
    layout: layoutData25,
    profile: profileData25,
    scene: sceneData25,
  },
  51: {
    configurator: configuratorData51,
    layout: layoutData51,
    profile: profileData51,
    scene: sceneData51,
  },
  58: {
    configurator: configuratorData58,
    layout: layoutData58,
    profile: profileData58,
    scene: sceneData58,
  },
  69: {
    configurator: configuratorData69,
    layout: layoutData69,
    profile: profileData69,
    scene: sceneData69,
  },
  23: {
    configurator: configuratorData23,
    layout: layoutData23,
    profile: profileData23,
    scene: sceneData23,
  },
  60: {
    configurator: configuratorData60,
    layout: layoutData60,
    profile: profileData60,
    scene: sceneData60,
  },
  132: {
    configurator: configuratorData132,
    layout: layoutData132,
    profile: profileData132,
    scene: sceneData132,
  },
  27: {
    configurator: configuratorData27,
    layout: layoutData27,
    profile: profileData27,
    scene: sceneData27,
  },
  77: {
    configurator: configuratorData77,
    layout: layoutData77,
    profile: profileData77,
    scene: sceneData77,
  },
  17: {
    configurator: configuratorData17,
    layout: layoutData17,
    profile: profileData17,
    scene: sceneData17,
  },
  123: {
    configurator: configuratorData123,
    layout: layoutData123,
    profile: profileData123,
    scene: sceneData123,
  },
  124: {
    configurator: configuratorData124,
    layout: layoutData124,
    profile: profileData124,
    scene: sceneData124,
  },
  3: {
    configurator: configuratorData3,
    layout: layoutData3,
    profile: profileData3,
    scene: sceneData3,
  },
  50: {
    configurator: configuratorData50,
    layout: layoutData50,
    profile: profileData50,
    scene: sceneData50,
  },
  // Upholstery Chair Configurator Data ends

// Wooden Products Configurator Data starts
  102: {
    configurator: configuratorData102,
    layout: layoutData102,
    profile: profileData102,
    scene: sceneData102,
  },
   103: {
    configurator: configuratorData103,
    layout: layoutData103,
    profile: profileData103,
    scene: sceneData103,
  },
  104: {
    configurator: configuratorData104,
    layout: layoutData104,
    profile: profileData104,
    scene: sceneData104,
  },
  108: {
    configurator: configuratorData108,
    layout: layoutData108,
    profile: profileData108,
    scene: sceneData108,
  },
  109: {
    configurator: configuratorData109,
    layout: layoutData109,
    profile: profileData109,
    scene: sceneData109,
  },
  149: {
    configurator: configuratorData149,
    layout: layoutData149,
    profile: profileData149,
    scene: sceneData149,
  },
  150: {
    configurator: configuratorData150,
    layout: layoutData150,
    profile: profileData150,
    scene: sceneData150,
  },
  151: {
    configurator: configuratorData151,
    layout: layoutData151,
    profile: profileData151,
    scene: sceneData151,
  },
  152: {
    configurator: configuratorData152,
    layout: layoutData152,
    profile: profileData152,
    scene: sceneData152,
  },
  144: {
    configurator: configuratorData144,
    layout: layoutData144,
    profile: profileData144,
    scene: sceneData144,
  },
  145: {
    configurator: configuratorData145,
    layout: layoutData145,
    profile: profileData145,
    scene: sceneData145,
  },
  153: {
    configurator: configuratorData153,
    layout: layoutData153,
    profile: profileData153,
    scene: sceneData153,
  },
  154: {
    configurator: configuratorData154,
    layout: layoutData154,
    profile: profileData154,
    scene: sceneData154,
  },
  155: {
    configurator: configuratorData155,
    layout: layoutData155,
    profile: profileData155,
    scene: sceneData155,
  },
  156: {
    configurator: configuratorData156,
    layout: layoutData156,
    profile: profileData156,
    scene: sceneData156,
  },
  157: {
    configurator: configuratorData157,
    layout: layoutData157,
    profile: profileData157,
    scene: sceneData157,
  },
  160: {
    configurator: configuratorData160,
    layout: layoutData160,
    profile: profileData160,
    scene: sceneData160,
  },
  161: {
    configurator: configuratorData161,
    layout: layoutData161,
    profile: profileData161,
    scene: sceneData161,
  },
  163: {
    configurator: configuratorData163,
    layout: layoutData163,
    profile: profileData163,
    scene: sceneData163,
  },
  164: {
    configurator: configuratorData164,
    layout: layoutData164,
    profile: profileData164,
    scene: sceneData164,
  },
  165: {
    configurator: configuratorData165,
    layout: layoutData165,
    profile: profileData165,
    scene: sceneData165,
  },
  166: {
    configurator: configuratorData166,
    layout: layoutData166,
    profile: profileData166,
    scene: sceneData166,
  },
  167: {
    configurator: configuratorData167,
    layout: layoutData167,
    profile: profileData167,
    scene: sceneData167,
  },
  176: {
    configurator: configuratorData176,
    layout: layoutData176,
    profile: profileData176,
    scene: sceneData176,
  },
  179: {
    configurator: configuratorData179,
    layout: layoutData179,
    profile: profileData179,
    scene: sceneData179,
  },
  180: {
    configurator: configuratorData180,
    layout: layoutData180,
    profile: profileData180,
    scene: sceneData180,
  },
  181: {
    configurator: configuratorData181,
    layout: layoutData181,
    profile: profileData181,
    scene: sceneData181,
  },
  182: {
    configurator: configuratorData182,
    layout: layoutData182,
    profile: profileData182,
    scene: sceneData182,
  },
  183: {
    configurator: configuratorData183,
    layout: layoutData183,
    profile: profileData183,
    scene: sceneData183,
  },
  184: {
    configurator: configuratorData184,
    layout: layoutData184,
    profile: profileData184,
    scene: sceneData184,
  },
  185: {
    configurator: configuratorData185,
    layout: layoutData185,
    profile: profileData185,
    scene: sceneData185,
  },
   186: {
    configurator: configuratorData186,
    layout: layoutData186,
    profile: profileData186,
    scene: sceneData186,
  },
   187: {
    configurator: configuratorData187,
    layout: layoutData187,
    profile: profileData187,
    scene: sceneData187,
  },
  188: {
    configurator: configuratorData188,
    layout: layoutData188,
    profile: profileData188,
    scene: sceneData188,
  },
    189: {
    configurator: configuratorData189,
    layout: layoutData189,
    profile: profileData189,
    scene: sceneData189,
  },
  190: {
    configurator: configuratorData190,
    layout: layoutData190,
    profile: profileData190,
    scene: sceneData190,
  },
  191: {
    configurator: configuratorData191,
    layout: layoutData191,
    profile: profileData191,
    scene: sceneData191,
  },
  195: {
    configurator: configuratorData195,
    layout: layoutData195,
    profile: profileData195,
    scene: sceneData195,
  },
  196: {
    configurator: configuratorData196,
    layout: layoutData196,
    profile: profileData196,
    scene: sceneData196,
  },
  197: {
    configurator: configuratorData197,
    layout: layoutData197,
    profile: profileData197,
    scene: sceneData197,
  },
  199: {
    configurator: configuratorData199,
    layout: layoutData199,
    profile: profileData199,
    scene: sceneData199,
  },
  200: {
    configurator: configuratorData200,
    layout: layoutData200,
    profile: profileData200,
    scene: sceneData200,
  },
  201: {
    configurator: configuratorData201,
    layout: layoutData201,
    profile: profileData201,
    scene: sceneData201,
  },
  202: {
    configurator: configuratorData202,
    layout: layoutData202,
    profile: profileData202,
    scene: sceneData202,
  },
  203: {
    configurator: configuratorData203,
    layout: layoutData203,
    profile: profileData203,
    scene: sceneData203,
  },
  205: {
    configurator: configuratorData205,
    layout: layoutData205,
    profile: profileData205,
    scene: sceneData205,
  },
  206: {
    configurator: configuratorData206,
    layout: layoutData206,
    profile: profileData206,
    scene: sceneData206,
  },
  192:{
    configurator: configuratorData192,
    layout: layoutData192,
    profile: profileData192,
    scene: sceneData192,
  },
  207: {
    configurator: configuratorData207,
    layout: layoutData207,
    profile: profileData207,
    scene: sceneData207,
  },
  208: {
    configurator: configuratorData208,
    layout: layoutData208,
    profile: profileData208,
    scene: sceneData208,
  },
  209: {
    configurator: configuratorData209,
    layout: layoutData209,
    profile: profileData209,
    scene: sceneData209,
  },
  210: {
    configurator: configuratorData210,
    layout: layoutData210,
    profile: profileData210,
    scene: sceneData210,
  },
  211: {
    configurator: configuratorData211,
    layout: layoutData211,
    profile: profileData211,
    scene: sceneData211,
  },
  212:{
    configurator: configuratorData212,
    layout: layoutData212,
    profile: profileData212,
    scene: sceneData212,
  },
  213:{
    configurator: configuratorData213,
    layout: layoutData213,
    profile: profileData213,
    scene: sceneData213,
  },
  214:{
    configurator: configuratorData214,
    layout: layoutData214,
    profile: profileData214,
    scene: sceneData214,
  },
  215:{
    configurator: configuratorData215,
    layout: layoutData215,
    profile: profileData215,
    scene: sceneData215,
  },
  216:{
    configurator: configuratorData216,
    layout: layoutData216,
    profile: profileData216,
    scene: sceneData216,
  },
  217:{
    configurator: configuratorData217,
    layout: layoutData217,
    profile: profileData217,
    scene: sceneData217,
  },
  225:{
    configurator: configuratorData225,
    layout: layoutData225,
    profile: profileData225,
    scene: sceneData225,
  },
  226:{
    configurator: configuratorData226,
    layout: layoutData226,
    profile: profileData226,
    scene: sceneData226,
  },
  227:{
    configurator: configuratorData227,
    layout: layoutData227,
    profile: profileData227,
    scene: sceneData227,
  },
  193:{
    configurator: configuratorData193,
    layout: layoutData193,
    profile: profileData193,
    scene: sceneData193,
  },
  95:{
    configurator: configuratorData95,
    layout: layoutData95,
    profile: profileData95,
    scene: sceneData95,
  },
  96:{
    configurator: configuratorData96,
    layout: layoutData96,
    profile: profileData96,
    scene: sceneData96,
  },
  97:{
    configurator: configuratorData97,
    layout: layoutData97,
    profile: profileData97,
    scene: sceneData97,
  },
  105:{
    configurator: configuratorData105,
    layout: layoutData105,
    profile: profileData105,
    scene: sceneData105,
  },
  106:{
    configurator: configuratorData106,
    layout: layoutData106,
    profile: profileData106,
    scene: sceneData106,
  },
  107:{
    configurator: configuratorData107,
    layout: layoutData107,
    profile: profileData107,
    scene: sceneData107,
  },
  110:{
    configurator: configuratorData110,
    layout: layoutData110,
    profile: profileData110,
    scene: sceneData110,
  },
  146:{
    configurator: configuratorData146,
    layout: layoutData146,
    profile: profileData146,
    scene: sceneData146,
  },
  168:{
    configurator: configuratorData168,
    layout: layoutData168,
    profile: profileData168,
    scene: sceneData168,
  },
  171:{
    configurator: configuratorData171,
    layout: layoutData171,
    profile: profileData171,
    scene: sceneData171,
  },
  172:{
    configurator: configuratorData172,
    layout: layoutData172,
    profile: profileData172,
    scene: sceneData172,
  },
  173:{
    configurator: configuratorData173,
    layout: layoutData173,
    profile: profileData173,
    scene: sceneData173,
  },
  177:{
    configurator: configuratorData177,
    layout: layoutData177,
    profile: profileData177,
    scene: sceneData177,
  },
  178:{
    configurator: configuratorData178,
    layout: layoutData178,
    profile: profileData178,
    scene: sceneData178,
  },
  194:{
    configurator: configuratorData194,
    layout: layoutData194,
    profile: profileData194,
    scene: sceneData194,
  },
  143:{
    configurator: configuratorData143,
    layout: layoutData143,
    profile: profileData143,
    scene: sceneData143,
  },
  148:{
    configurator: configuratorData148,
    layout: layoutData148,
    profile: profileData148,
    scene: sceneData148,
  },
  141:{
    configurator: configuratorData141,
    layout: layoutData141,
    profile: profileData141,
    scene: sceneData141,
  },
  140:{
    configurator: configuratorData140,
    layout: layoutData140,
    profile: profileData140,
    scene: sceneData140,
  },
  147:{
    configurator: configuratorData147,
    layout: layoutData147,
    profile: profileData147,
    scene: sceneData147,
  },
  // Wooden Products Configurator Data ends

  // multiple configurator data start here.
  204: {
    configurator: configuratorData204,
    layout: layoutData204,
    profile: profileData204,
    scene: sceneData204,
  },
  198: {
    configurator: configuratorData198,
    layout: layoutData198,
    profile: profileData198,
    scene: sceneData198,
  },
  130: {
    configurator: configuratorData130,
    layout: layoutData130,
    profile: profileData130,
    scene: sceneData130,
  },
  91: {
    configurator: configuratorData91,
    layout: layoutData91,
    profile: profileData91,
    scene: sceneData91,
  },
  26: {
    configurator: configuratorData26,
    layout: layoutData26,
    profile: profileData26,
    scene: sceneData26,
  },
  19: {
    configurator: configuratorData19,
    layout: layoutData19,
    profile: profileData19,
    scene: sceneData19,
  },
  46: {
    configurator: configuratorData46,
    layout: layoutData46,
    profile: profileData46,
    scene: sceneData46,
  },
  7: {
    configurator: configuratorData7,
    layout: layoutData7,
    profile: profileData7,
    scene: sceneData7,
  },
  221: {
    configurator: configuratorData221,
    layout: layoutData221,
    profile: profileData221,
    scene: sceneData221,
  },
  82: {
    configurator: configuratorData82,
    layout: layoutData82,
    profile: profileData82,
    scene: sceneData82,
  },
  71: {
    configurator: configuratorData71,
    layout: layoutData71,
    profile: profileData71,
    scene: sceneData71,
  },
  83: {
    configurator: configuratorData83,
    layout: layoutData83,
    profile: profileData83,
    scene: sceneData83,
  },
  162: {
    configurator: configuratorData162,
    layout: layoutData162,
    profile: profileData162,
    scene: sceneData162,
  },
  63: {
    configurator: configuratorData63,
    layout: layoutData63,
    profile: profileData63,
    scene: sceneData63,
  },
  424: {
    configurator: configuratorData424,
    layout: layoutData424,
    profile: profileData424,
    scene: sceneData424,
  },
  426: {
    configurator: configuratorData426,
    layout: layoutData426,
    profile: profileData426,
    scene: sceneData426,
  }, 
  // multiple configurator data end here.
};